import Typography from "@mui/material/Typography";
import { useCallback } from "react";
import { useQuery } from "react-query";
import { listInsights } from "../../../services/insights";
import { coastEnrichment } from "../../../services/enrichment";
import { Autocomplete } from "../../Autocomplete";
import Skeleton from "@mui/material/Skeleton";
import { useStyles } from "./styles";
import { CountUp } from "../../CountUp";
import { useFormikContext } from "formik";
import { CreateEnrichmentData } from "../../../types/enrichment";

export function Insights() {
  const formik = useFormikContext<CreateEnrichmentData>();
  const styles = useStyles();

  const insights = useQuery("insights", listInsights);
  const coast = useQuery(
    ["coast", formik.values?.insight?.idListProspectei],
    async () => {
      const response = await coastEnrichment(
        formik.values?.insight?.idListProspectei
      );
      return response;
    },
    {
      enabled: Boolean(formik.values?.insight?.idListProspectei),
      onSuccess: (response) => {
        formik.setFieldValue("coast", response.total_price);
        formik.setFieldValue("quantity", response.quantity);
      },
    }
  );

  const handleChange = useCallback(
    (_: any, insight: any) => {
      const insightData = {
        nameList: insight.nameList,
        idListProspectei: insight.idListProspectei,
      };
      formik.setFieldValue("insight", insightData);
    },
    [formik]
  );

  return (
    <>
      <Typography color="primary">
        Escolha uma audiência para enriquecer
      </Typography>
      <Autocomplete
        size="small"
        label="Audiências"
        loading={insights.isLoading}
        options={insights.data}
        getOptionLabel={(option) => option.nameList}
        onChange={handleChange}
        value={formik.values.insight}
      />
      <Typography color="primary">Informações do enriquecimento</Typography>

      <div className={styles.textCoast}>
        <Typography>Créditos consumidos: </Typography>
        {coast.isLoading ? (
          <Skeleton variant="text" width="30%" />
        ) : (
          <CountUp
            start={0}
            end={coast.data?.quantity}
            marginBottom={1}
            marginTop={1}
          />
        )}
      </div>
    </>
  );
}
